/**
 * Created by mac on 12/23/20
 */

const ViewFactory = function (component, unitView) {
    let componentView;
    let x = unitView.width / 2, y = unitView.height / 2;
    let zOrder = 0;

    if (component instanceof Collectible) {
        componentView = new CollectibleView(component, unitView);
    } else if (component instanceof Merge2Generator) {
        componentView = new Merge2GeneratorView(component, unitView);
    } else if (component instanceof Grounded) {
        componentView = new GroundedView(component, unitView);
        x = unitView.width * unitView.anchorX;
        y = unitView.height * unitView.anchorY;
        zOrder = -1;
    } else if (component instanceof FieldReward) {
        componentView = new FieldRewardView(component, unitView);
        zOrder = 1;
    } else if (component instanceof ThirdElement) {
        componentView = new ThirdElementView(component, unitView);
    } else if (component instanceof LockedComponent) {
        componentView = new LockedComponentView(component, unitView);
    } else if (component instanceof MergeComponent) {
        componentView = new MergeComponentView(component, unitView);
    } else if (component instanceof CupComponent) {
        componentView = new CupComponentView(component, unitView);
    } else if (component instanceof ScissorsComponent) {
        componentView = new ScissorsComponentView(component, unitView);
    } else if (component instanceof RainbowComponent) {
        componentView = new RainbowComponentView(component, unitView);
    } else if (component instanceof GeneratorBoosterComponent) {
        componentView = new GeneratorBoosterComponentView(component, unitView);
    } else if (component instanceof PinComponent) {
        componentView = new PinComponentView(component, unitView);
    }

    if (componentView instanceof cc.Node) {
        componentView.setAlignment(x, y);
        componentView.setAnchorPoint(0.5, 0.5);
        unitView.addChild(componentView, zOrder);
    }

    if (componentView) {
        component.setView(componentView);
    }
};